import { IError } from './ErrorHandle';
import { HttpClient } from './HttpClient';

export class ErrorStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public async logError(error: IError) {
        await this.httpClient.post<IError>(`/api/v1/error`, error);
    }

    private readonly httpClient: HttpClient;
}
